import axios from 'axios';
import store from './store';
import router from './router';
// import sendDiscordNotification from './LogsDiscord';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  // timeout: 100000,
});

const discordWebhookUrl = process.env.VUE_APP_ERROR_LOG_DISCORD;

// Função para enviar notificação ao Discord
async function sendDiscordNotification(error) {
  if( process.env.NODE_ENV === 'development' || error.response?.status === 401) return

  const message = {
    username: "Error Monitor",
    embeds: [
      {
        title: "🚨 Novo Request Error Detectado!",
        description: `**Erro:** ${error.message || "Erro não especificado"}`,
        color: 16711680,
        fields: [
          { name: "BASE_URL", value: error.config?.baseURL || "Desconhecido" },
          { name: "URL", value: error.config?.url || "Desconhecido" },
          { name: "Método", value: error.config?.method.toUpperCase(), inline: true },
          { name: "Status", value: `${error.response?.status || "Desconhecido"}`, inline: true },
          {
            name: "Headers",
            value: `\`\`\`${JSON.stringify(error.config?.headers || {}, null, 2)}\`\`\``,
          },
          {
            name: "Data",
            value: `\`\`\`${JSON.stringify(error.config?.data || {}, null, 2)}\`\`\``,
          },
          {
            name: "Response Data",
            value: `\`\`\`${JSON.stringify(error.response?.data || {}, null, 2)}\`\`\``,
          },
          {
            name: "Stack",
            value: `\`\`\`${JSON.stringify(error.stack || {}, null, 2)}\`\`\``,
          },
        ],
        timestamp: new Date().toISOString(),
      },
    ],
  };

  try {
    await api.post(discordWebhookUrl, message);
  } catch (e) {
    console.error("error log", e);
  }
}

api.interceptors.response.use(
  response =>  {
    if (response.status && response.status === 401) {
      store.dispatch('auth/logout');
      if (router.currentRoute.value.name !== 'Login') {
        router.push({ name: 'Login' });
      }
    }

    return response
  },
  error => {
    sendDiscordNotification(error)

    if (error.response && error.response.status === 401) {
      store.dispatch('auth/logout');
      if (router.currentRoute.value.name !== 'Login') {
        router.push({ name: 'Login' });
      }
    }

    return Promise.reject(error);
  }
);

export default api;